const i18n = {
  methods: {
    i18n(name, ...arg) {
      return this.$store.getters.i18n(name, ...arg);
    },
  },
};

export default i18n;



// WEBPACK FOOTER //
// ./src/mixins/i18n.js